import React from 'react'

const PrevSection = ({ section }) => {
  return (
    <a href={section} className='sm:prev-section-button'>
    </a>
  )
}

export default PrevSection